<app-block-dnm></app-block-dnm>

<footer class="footer footer-big">

  <div class="container">
    <hr />
    <div class="row mt-2">
      <div class="col-md-3 col-sm-6 col-12 ml-auto mr-auto">
        <h5>Our Vision</h5>
        eMD's vision is to be the leading solutions provider to the healthcare market and serve our clients with
        integrity and dedication.
      </div>
      <div class="col-md-9 ml-auto mr-auto col-sm-9 col-12">
        <div class="row">
          <div class="col-md-3 col-sm-3 col-6">
            <div class="links">
              <ul class="uppercase-links stacked-links">
                <li>
                  <a [routerLink]="['']">
                    Home
                  </a>
                </li>
                <li>
                  <a [routerLink]="['contact_us']">
                    Contact Us
                  </a>
                </li>
                <li>
                  <a [routerLink]="['support']">
                    Support
                  </a>
                </li>
                <li>
                  <a [routerLink]="['info_popi']">
                    POPIA
                  </a>
                </li>
                <li>
                  <a [routerLink]="['info_news']">
                    NEWS
                  </a>
                </li>
              </ul>
              <ul class="stacked-links">
                <li>

                  <a class="link text-info" href="tel:0860 018 363"><strong>0860 018 363</strong></a>


                </li>
                <li>
                  <a class="link text-info" href="email:info@e-md.co.za"><strong>info@e-md.co.za</strong></a>

                </li>
                <li *ngIf="is_international==false">
                  www.e-md.co.za

                </li>

              </ul>
            </div>
          </div>




          <div class="col-md-6 col-sm-6 col-12">
            <div class="links">
              <ul class="stacked-links">

                <li>
                  <a href="https://www.hpcsa.co.za/" target="_blank">
                    Health Professions Council of South Africa
                  </a>
                </li>
                <li>
                  <a href="https://www.medicalschemes.co.za/" target="_blank">
                    Council for Medical Schemes
                  </a>
                </li>

              </ul>


            </div>

            <div class="row align-items-center justify-content-center">
              <div class="col-4 col-md-4">
                <a href="https://www.samedical.org/" target="_blank">
                  <img class="img img-responsive" src="./assets/img/brand/SAMA-Logo-Transparent_Small.png"
                    style="width: 100%;">
                </a>
              </div>
              <div class="col-4 col-md-4">
                <a href="https://shop.mpconsulting.co.za/" target="_blank">
                  <img class="img img-responsive" src="./assets/img/brand/mpc.gif" style="width: 100%;">
                </a>
              </div>

              <div class="col-4 col-md-4">
                <a href="https://www.dischem.co.za/" target="_blank">
                  <img class="img img-responsive" src="./assets/img/brand/Dis-Chem.png" style="width: 100%;">
                </a>
              </div>


            </div>



          </div>

          <div class="col-md-3 col-6">
            <div class="row">
              <div class="social-area">

                <ng-container *ngFor="let social of socialData">

                  <a href="{{social.url}}" class="btn btn-just-icon btn-round btn-{{social.icon}} mr-1" target="_blank">
                    <i class="fa fa-{{social.icon}}" aria-hidden="true"></i>
                  </a>

                </ng-container>
              </div>
            </div>

          </div>
        </div>
        <hr />
        <div class="copyright">
          <div class="pull-left">
            © {{currentYear}} eMD Technologies (Pty) Ltd | Powered by eMD Tech® (Under License)
          </div>
          <div class="links pull-right">
            <ul>

              <li>
                <a [routerLink]="['pp']">
                  Privacy Policy
                </a>
              </li>
              |
              <li>
                <a [routerLink]="['tandc']">
                  Terms & Conditions
                </a>
              </li>

            </ul>
          </div>
        </div>
      </div>
    </div>

  </div>
</footer>